<div class="fixed-page-title">
  <div class="page-header">
    <div>
      <p class="page-title">
        {{resourceKeyValue.idnsHeading}}
      </p>
    </div>
    <div>
      <button class="btn btn-primary" id="btnCreateIDN"
        [routerLink]="['add-idn']">{{resourceKeyValue.idnCreateNewIDNs}}</button>
    </div>
  </div>
</div>
<div class="form-title padding-top-4em">
  <form content [formGroup]="searchIdnsForm" id="searchIdnsForm" class="w-100">
    <div class="form-group">
      <div class="search">
        <div class="input-group mb-2 tertiary-search w-100">
          <div class="has-clear w-100">
            <input type="text" class="form-control search-txt w-25" id="term"
              placeholder={{resourceKeyValue.searhByIDNName}} formControlName="term" (keyup)="search($event)">
          </div>
          <span class="input-group-append">
            <div class="input-group-text btn-tertiary-search border-0"><i class="icon-search-bold"></i></div>
          </span>
        </div>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!isLoading">
  <div class="table-responsive">
    <table id="idnTable" class="table table-striped table-hover" #idnTable>
      <thead class="column-sort">
        <tr>
          <th (click)="sortableState ='1'; isDefaultSort=false"
            [ngClass]="[sortableState == '1' ? 'sorting':'' ,isDefaultSort==true ? 'sorted-asc':'',idns?.length===0?'disabled-header':'']"
            scope="col" [appSort]="idns" data-order="desc" data-name="name" tabindex="0" class="tabfocusable w-20">
            <span>{{resourceKeyValue.idnName}}</span>
          </th>
          <th (click)="sortableState ='2'"
            [ngClass]="{'sorting':sortableState == '2','disabled-header':idns?.length===0}" scope="col" [appSort]="idns"
            data-order="desc" data-name="facilityCount" tabindex="0" class="tabfocusable w-10">
            <span>{{resourceKeyValue.idnNoFacilities}}</span>
          </th>
          <th (click)="sortableState ='3'"
            [ngClass]="{'sorting':sortableState == '3','disabled-header':idns?.length===0}" scope="col" [appSort]="idns"
            data-order="desc" data-name="accountNumber" tabindex="0" class="tabfocusable w-20 pl-5">
            <span>{{resourceKeyValue.idnAccountNumber}}</span>
          </th>
          <th scope="col" class="text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let idn of idns | slice: (pageIndex-1) * pageSize : pageIndex * pageSize; index as i">
          <td class="idn-name" scope="row">{{idn.name}}</td>
          <td scope="row" class="text-right">{{idn?.facilityCount || 0}}</td>
          <td scope="row" class="pl-5">{{idn.accountNumber}}</td>
          <td scope="row" class="text-right">
            <button class="btn btn-secondary btn-sm"
              [routerLink]="['edit-idn',idn.id]">{{resourceKeyValue.edit}}</button>
          </td>
        </tr>
        <tr *ngIf="idns?.length===0">
          <td colspan="4" class="empty-grid">
            <p class="empty-grid-header">{{resourceKeyValue.noDataAvailable}}</p>
            <p class="empty-grid-body-text">{{resourceKeyValue.noIDNDetails}}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="table-footer" *ngIf="idns?.length>0">
    <div id="pagination" style="display: block;">
      {{resourceKeyValue.page}} <b>{{pageIndex}}</b> {{resourceKeyValue.of}} {{numberOfPages}}
    </div>
    <div class="rpp">
      <span>{{resourceKeyValue.showRows}}</span>
      <div class="dropdown dropdown-sm" role="navigation">
        <button class="btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" id="pagination"
          aria-haspopup="true" aria-expanded="false" aria-controls="dropdownPagination">{{pageSizeDisplay}}</button>
        <div class="dropdown-menu" aria-labelledby="pagination" id="dropdownPagination">
          <ng-container *ngFor="let page of pageSizeOptions">
            <button *ngIf='isNumber(page)' (click)="pageSizeDisplay=page; pageSize=page; refreshIdns();" role="menuitem"
              ngbDropdownItem>{{page}}</button>
            <button *ngIf='!isNumber(page)'
              (click)="pageSizeDisplay=page.showAll; pageSize=idns?.length; refreshIdns();" role="menuitem"
              ngbDropdownItem>{{page.showAll}}</button>
          </ng-container>
        </div>
      </div>
    </div>
    <ngb-pagination class="d-flex justify-content-end" [boundaryLinks]="true" [collectionSize]="totalNumber"
      [(page)]="pageIndex" [maxSize]=5 [pageSize]="pageSize">
    </ngb-pagination>
  </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>